import React, { useEffect } from 'react';
import classNames from 'classnames/bind';
import { connect, ConnectedProps } from 'react-redux';
import Text from '../../atoms/Text';
import Image from '../../atoms/ImageView';
import { Feature, Variant } from '../ABFeature';
import properties from '../../../modules/ajio-util/properties';
import { gtmEventPush } from '../../../modules/ga/GTMdatalayer';
import { getSisFlag } from '../../selectors/metaData';
import { getAppInstallFlag, getAppConfig, getAppsFlyerConfig } from '../../selectors/featureFlagsSelector';
import { triggerApp, isMicroApp } from './utils';
import getMobileOperatingSystem from '../../utils/DetectDeviceType';

import styles from './appinstall.module.pcss';

const cx = classNames.bind(styles);
const imgPath = `${properties.getProperty('imageBaseUrl')}/static/img`;

const mapStateToProps = (state: import('../../types/rootState').RootState) => ({
  appInstallFeature: getAppInstallFlag(state),
  appConfig: getAppConfig(state),
  sisFlag: getSisFlag(state),
  appsFlyerConfig: getAppsFlyerConfig(state?.flags)
});

const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

const FooterBanner = ({
  id = '',
  pagetype,
  appInstallFeature = {},
  appConfig,
  sisFlag,
  appsFlyerConfig
}: PropsFromRedux): Element.JSX => {
  const { footerBanner = {} } = appInstallFeature;

  const { andoridImage, iosImage, text } = footerBanner;
  const doNotRender = appInstallFeature[pagetype] !== 'ON' || sisFlag || isMicroApp();
  const impressionId = pagetype === 'footer' && id === 'footerAppInstall' ? 'impression_app-install__footer' : '';

  const onScroll = () => {
    const imresssionId = document.querySelector(`.${impressionId}`);

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.intersectionRatio > 0.5) {
          const impressionFired = JSON.parse(localStorage.getItem(`${impressionId}`)) ?? false;
          if (!impressionFired) {
            localStorage.setItem(impressionId, JSON.stringify(true));

            gtmEventPush({
              event: 'app_install_widget_impression',
              category: 'widget interaction',
              action: 'app install widget impresssion',
              label: pagetype
            });
          }
        }
      });
    });

    if (imresssionId) {
      observer.observe(imresssionId);
    }
  };

  // useEffect(() => {
  //   if (!doNotRender) {
  //     gtmEventPush({
  //       event: 'app_install_widget_impression',
  //       category: 'widget interaction',
  //       action: 'app install widget impresssion',
  //       label: pagetype
  //     });
  //   }
  // }, []);

  useEffect(() => {
    window.addEventListener('scroll', onScroll);
    window.addEventListener('beforeunload', () => {
      localStorage.removeItem(impressionId);
    });

    return () => {
      window.removeEventListener('beforeunload', () => {
        localStorage.removeItem(impressionId);
      });
      window.removeEventListener('scroll', () => {});
    };
  }, []);

  if (doNotRender) {
    return null;
  }
  const device = getMobileOperatingSystem();
  let deviceImage = '';
  let altText = '';
  if (device === 'Android') {
    deviceImage = `${imgPath}/${andoridImage}`;
    altText = 'Play store icon'
  } else if (device === 'iOS') {
    deviceImage = `${imgPath}/${iosImage}`;
    altText = 'App store icon'
  }
  return (
    <Feature featureName="appInstall">
      <Variant id="0">
        <section className={cx('appInstallFooter', impressionId)} id={id}>
          <Text variant="T3" weight="bold">
            {text}
          </Text>
          <div className={cx('footerImageApp')}>
            <Image
              handleClick={() => triggerApp(appConfig, pagetype, '', appsFlyerConfig)}
              src={deviceImage}
              className={cx('footerImage')}
              alt={altText}
            />
          </div>
        </section>
      </Variant>
      <Variant id="1">{null}</Variant>
    </Feature>
  );
};

export default connector(FooterBanner);
